import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyEn = () => {
    return <SupportPrivacyPolicy languageCode="en" />
}

export default SupportPrivacyPolicyEn
